import { useEffect, type ReactNode } from 'react';

import { isOfflineDemoActiveAtBoot } from 'src/features/offline-demo/boot';

import { connectivityCoordinator } from './connectivity-service';

type Props = { children: ReactNode };

export function ConnectivityProvider({ children }: Props) {
  useEffect(() => {
    if (isOfflineDemoActiveAtBoot()) {
      connectivityCoordinator.stop();
      return undefined;
    }
    connectivityCoordinator.start().catch(() => undefined);
    return () => connectivityCoordinator.stop();
  }, []);

  return children;
}
